import { useTranslation } from "react-i18next";
import { CloseActivityPanelIcon } from "shared/assets/svg/CloseActivityPanelIcon";
import colorsStore from "shared/store/colorsStore";

type ConstraintsPanelHeaderProps = {
  expanded: boolean;
  onClose: () => void;
  title: string;
};
export const HeaderPanel: React.FC<ConstraintsPanelHeaderProps> = ({
  expanded,
  onClose,
  title,
}) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const { t } = useTranslation();

  const iconSizeClass2 = `icon-size-16-16`;

  return (
    <div
      className={"flex-2 relative rounded-xl"}
      style={{ marginTop: 40, marginLeft: 20, marginRight: 20 }}
    >
      <div className="flex items-center justify-between">
        <div
          className={(expanded ? "lg:visible " : "lg:hidden ") + " font-bold"}
          style={{ fontSize: 18, color: colorsConfig.finecoBlack }}
        >
          {t(title)}
        </div>

        <div className="cursor-pointer" onClick={() => onClose()}>
          <CloseActivityPanelIcon
            className={iconSizeClass2}
            color={colorsConfig.finecoBlack}
          />
        </div>
      </div>
    </div>
  );
};
